import React from "react";

const StepsTimeline = () => {
  const steps = [
    { id: 1, title: "Safe & Reliable" },
    { id: 2, title: "Quick Approvals" },
    { id: 3, title: "Flexible Loan Options" },
    { id: 4, title: "Transparent Process" },
    { id: 5, title: "Secure & Confidential" },
    { id: 6, title: "Dedicated Support" },
  ];

  const styles = {
    // Desktop styles
    container: {
      position: "relative",
      width: "100%",
      maxWidth: "1200px",
      margin: "5px auto",
      padding: "0 20px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      minHeight: "200px",
      marginBottom: "40px"
    },
//     leftCap: {
//   position: "absolute",
//   top: "50%",
//   left: "10%",
//   width: "14px",
//   height: "7px",
//   transform: "translate(-100%, -50%)",
//   borderTop: "2px dotted #d1d5db",
//   borderLeft: "2px dotted #d1d5db",
//   borderTopLeftRadius: "12px",
//   background: "#ffffff",
//   zIndex: 2,
// },

// rightCap: {
//   position: "absolute",
//   top: "55%",
//   left: "88%",
//   width: "30px",
//   height: "20px",
//   transform: "translate(0, -50%)",
//   borderTop: "2px dotted #d1d5db",
//   borderRight: "2px dotted #d1d5db",
//   borderTopRightRadius: "12px",
//   background: "#ffffff",
//   zIndex: 2,
// },

    line: {
      position: "absolute",
      top: "50%",
      left: "10%",
      right: "10%",
      borderTop: "2px dotted #d1d5db",
      transform: "translateY(-50%)",
      zIndex: 1,
    },
    step: {
      position: "relative",
      flex: 1,
      textAlign: "center",
      zIndex: 2,
    },
    stepContent: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "12px",
      position: "absolute",
      left: "50%",
      transform: "translateX(-50%)",
    },
    circle: {
      width: "36px",
      height: "36px",
      backgroundColor: "#ffffff",
      borderRadius: "50%",
      border: "2px solid #e5e7eb",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#374151",
      fontSize: "15px",
      fontWeight: 600,
      zIndex: 2,
      position: "relative",
    },
    label: {
      color: "#1f2937",
      fontSize: "13px",
      fontWeight: 500,
      whiteSpace: "nowrap",
      maxWidth: "140px",
      lineHeight: "1.4",
    },
    connector: {
      position: "absolute",
      left: "50%",
      width: "2px",
      height: "40px",
      transform: "translateX(-50%)",
      borderLeft: "2px dotted #d1d5db",
    },
    topStepContent: { 
      bottom: "calc(50% + 45px)",
      flexDirection: "column-reverse",
    },
    bottomStepContent: { 
      top: "calc(50% + 45px)",
    },
    topConnector: { 
      bottom: "50%",
      height: "45px",
    },
    bottomConnector: { 
      top: "50%",
      height: "45px",
    },

    // Mobile styles
    mobileContainer: {
      position: "relative",
      width: "100%",
      maxWidth: "400px",
      margin: "5px auto",
      padding: "20px",
    },
    mobileVerticalLine: {
      position: "absolute",
      left: "37px",
      top: "20px",
      bottom: "60px",
      borderLeft: "2px dotted #d1d5db",
      zIndex: 1,
    },
    mobileStep: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      gap: "20px",
      marginBottom: "40px",
      zIndex: 2,
    },
    mobileCircle: {
      width: "36px",
      height: "36px",
      backgroundColor: "#ffffff",
      borderRadius: "50%",
      border: "2px solid #e5e7eb",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#374151",
      fontSize: "15px",
      fontWeight: 600,
      flexShrink: 0,
    },
    mobileLabel: {
      color: "#1f2937",
      fontSize: "15px",
      fontWeight: 500,
      lineHeight: "1.4",
    },
  };

  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (isMobile) {
    return (
      <div style={styles.mobileContainer}>
        <div style={styles.mobileVerticalLine}></div>
        {steps.map((step) => (
          <div key={step.id} style={styles.mobileStep}>
            <div style={styles.mobileCircle}>{step.id}</div>
            <div style={styles.mobileLabel}>{step.title}</div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.line}></div>
{/* <div style={styles.leftCap}></div>
<div style={styles.rightCap}></div> */}

      {steps.map((step, index) => {
        const isTop = index % 2 === 0;

        return (
          <div key={step.id} style={styles.step}>
            <div
              style={{
                ...styles.connector,
                ...(isTop ? styles.topConnector : styles.bottomConnector),
              }}
            ></div>

            <div
              style={{
                ...styles.stepContent,
                ...(isTop ? styles.topStepContent : styles.bottomStepContent),
              }}
            >
              <div style={styles.circle}>{step.id}</div>
              <div style={styles.label}>{step.title}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StepsTimeline;